import { FC } from "react";
import { IconProps } from "./types";

export const ArrowUpCircleLine: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      d="M18 10.845a.58.58 0 0 0-.17-.41l-5.415-5.391a.605.605 0 0 0-.64-.126.581.581 0 0 0-.19.126L6.17 10.432a.595.595 0 0 0-.127.638.574.574 0 0 0 .316.316.586.586 0 0 0 .636-.126l4.419-4.398v11.68a.581.581 0 0 0 .585.583.587.587 0 0 0 .586-.583V6.86l4.419 4.397a.585.585 0 0 0 .996-.411z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.279 19.61A12 12 0 1 0 2.722 4.39a12 12 0 0 0 18.557 15.22zM2.95 18.043a10.884 10.884 0 0 1-1.834-6.047A10.898 10.898 0 0 1 11.999 1.112 10.884 10.884 0 1 1 2.95 18.043z"
      fill={fill}
    />
  </svg>
);
